export default __webpack_public_path__ + "0bb394cff9442704557c9d86c6077e52.glb";